// Genre Icons Map
import {
  Compass, Sparkles, Moon, GraduationCap, Smile, Heart, BookOpen
} from "lucide-react";

export const genreIcons = {
  adventure: Compass,
  fantasy: Sparkles,
  bedtime: Moon,
  educational: GraduationCap,
  funny: Smile,
  friendship: Heart
};

export const getGenreIcon = (genre) => genreIcons[genre] || BookOpen;

// Background music URLs (royalty-free lullabies/ambient)
export const BACKGROUND_MUSIC = {
  lullaby: "https://cdn.pixabay.com/download/audio/2022/01/18/audio_d0c6ff1bab.mp3",
  peaceful: "https://cdn.pixabay.com/download/audio/2022/10/25/audio_946bc3eb0d.mp3",
  adventure: "https://cdn.pixabay.com/download/audio/2021/11/25/audio_91b32e02f9.mp3"
};

// TTS Voice options
export const VOICE_SPEEDS = {
  slow: 0.8,
  normal: 1.0,
  fast: 1.2
};
